import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';

const openRegistrationModal = (): void => {
  getContext()
    .handlers.openAuthScreen({ action: 'signup', source: MINIAPP_PACKAGE_ID })
    .catch((error: unknown) =>
      errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN)
    );
};

export default openRegistrationModal;
